import axios from "axios";
import { toast } from "sonner";
import { FileSignature, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => new Date(iso).toLocaleString("en-US", { dateStyle: "medium", timeStyle: "short" });

const downloadPdf = async (c, token) => {
  try {
    const { data } = await axios.get(`${API}/admin/contracts/${c.id}/pdf`, {
      headers: { Authorization: `Bearer ${token}` },
      responseType: "blob",
    });
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `ProExec-Agreement-${c.name.replace(/\s+/g, "-")}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    toast.error("Could not download the PDF.");
  }
};

export default function ContractsList({ contracts, token }) {
  return (
    <div data-testid="admin-contracts-list" className="flex flex-col gap-4">
      {contracts.length === 0 && <p style={{ color: "var(--text-secondary)" }}>No contracts sent yet.</p>}
      {contracts.map((c) => {
        const signed = c.status === "signed";
        return (
          <div
            key={c.id}
            data-testid={`admin-contract-${c.id}`}
            className="rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3"
            style={{ backgroundColor: "#fff", border: "1px solid var(--border-light)" }}
          >
            <div className="text-sm" style={{ color: "var(--text-secondary)" }}>
              <div className="flex items-center gap-2 mb-1">
                <FileSignature size={15} color="var(--rose-mocha)" />
                <span className="font-medium text-base" style={{ color: "var(--text-primary)" }}>{c.name}</span>
              </div>
              <p>{c.email}</p>
              <p>Sent {fmt(c.created_at)}</p>
              {signed && <p>Signed by <em>{c.signed_name}</em> · {fmt(c.signed_at)}</p>}
            </div>
            <div className="flex items-center gap-2 self-start sm:self-center">
            {signed && (
              <button
                data-testid={`admin-contract-pdf-${c.id}`}
                onClick={() => downloadPdf(c, token)}
                className="inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs"
                style={{ border: "1px solid var(--mocha-brown)", color: "var(--mocha-brown)" }}
              >
                <Download size={13} /> PDF
              </button>
            )}
            <span
              data-testid={`admin-contract-status-${c.id}`}
              className="text-xs tracking-[0.15em] uppercase px-3 py-1.5 rounded-full"
              style={{
                backgroundColor: signed ? "var(--mocha-brown)" : "#F3DAD5",
                color: signed ? "#FBF6F3" : "var(--rose-mocha-deep)",
              }}
            >
              {signed ? "Signed" : "Awaiting signature"}
            </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
